import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import {  faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClearableSearch from '../../../../uiControls/ClearableSearch';

import { ApplicableTableSettings, codesAesScheduleBList } from '../../../../tableSettings';

import useFastStorage from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';

import ApplicationContext from '../../../../ApplicationContext';
import useSystemSettings from '../../../../hooks/useSystemSettings';
import { Search } from '../../../../filtering';
import { Portal } from 'react-portal';
import { CodeScheduleBListItem } from '../../../../fms.data/models/CodeScheduleBListItem';
import { JobNames } from '../../../../framework.core/JobNames';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import EditableTable, { CellData, EditableTableHandle, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import TextBox from '../../../../ui/TextBox';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';

import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';

function CodeRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-schbcode-${row.index}`} maxLength={12} value={data[row.index].code} onChange={(e) => {
          changeLineItem(row.index, {code: e.target.value, isUpdate: true})
          }} />
      </div>
    );
}

function DescriptionRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-schdescription-${row.index}`} maxLength={50} value={data[row.index].sdescription} onChange={(e) => {
        changeLineItem(row.index, {sdescription: e.target.value, isUpdate: true})
          }} />
      </div>
    );
}

function Unit1Renderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-schunit1-${row.index}`} maxLength={3} value={data[row.index].unit1} onChange={(e) => {
        changeLineItem(row.index, {unit1: e.target.value, isUpdate: true})
          }} />
      </div>
    );
}

function Unit2Renderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-schunit2-${row.index}`} maxLength={3} value={data[row.index].unit2} onChange={(e) => {
         changeLineItem(row.index, {unit2: e.target.value, isUpdate: true})
          }} />
      </div>
    );
}

class EditableCodeExportInfoListItem extends CodeScheduleBListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
}

function formatElement(data:any) {
  const result = new EditableCodeExportInfoListItem();
  result.code = data.code;
  result.sdescription = data.sdescription;
  result.unit1 = data.unit1;
  result.unit2 = data.unit2;
  result.cid = data.cid;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data:Array<any>) {
  return data.map(d => formatElement(d));
}

function Scheduleb() {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
    //ifmsReferenceFilesCancel: () => {},
  }});
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const systemSettings = useSystemSettings();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const tableRef = useRef<EditableTableHandle>(null);
  const masterTableRef = useRef<EditableTableHandle>(null);
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState(Array<String>());
  //const addingToTheFirstLine = useRef(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  
  const [data, _setData, removeData, /*dataRef*/] = useFastStorage(`ifms-referenceFiles-scheduleb-list`, []);

  const savedDataRef = useRef<Array<CodeScheduleBListItem>>([]);
  const oriData = useRef<CodeScheduleBListItem[]>([]);

  //const [ei, setEi, , ediRef] = useFastStorage(`ifms-referenceFiles-scheduleb-editindex`, -1);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-scheduleb-orderby`, {
    orderBy: 'code',
    orderByAscending: true,
    general1: 'Code',
    pageSize: systemSettings.defaultPageSize,
  });
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeScheduleB);
  const [focusFirstCell, setFocusFirstCell] = useState(true);

  const listItemType = 'CodeScheduleBListItem';
  
  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }
  
  async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  function setData(d: Array<any>, callByFetchData: boolean = false) {
    setFocusFirstCell(callByFetchData);
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeScheduleBListItem, oriData.current, d));
  }

  const tableHeight = 520;

  async function fetchData(api:any, search:Search) {
    setLoading(true);

    const searchModel = CodeScheduleBListItem.calculateSearchParameters(search);
    const apiResult = await api.getListItems(JobNames.ScheduleB,
      listItemType,
      searchModel, 1, search.pageSize);
    // const apiResultforAll = await api.getListItems(JobNames.ScheduleB,
    //   listItemType,
    //   searchModel,
    //   1);

    oriData.current = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    setData(formatData(apiResult && apiResult.entities ? apiResult.entities : []), true);
    savedDataRef.current = apiResult && apiResult.entities ? apiResult.entities : [];

    // if(apiResultforAll && apiResultforAll.entities){
    //   setAllData(apiResultforAll.entities.map((a: CodeScheduleBListItem) => a.code.toLowerCase()));
    // }

    setFocusFirstCell(false);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    async function executeAsyncFunc() {
      if (data.length === 0)
        await reload('');
      else{
        oriData.current = _.cloneDeep(data);
        savedDataRef.current = _.cloneDeep(data);
      }
    }
    executeAsyncFunc();
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function reload(generalText:string = '') {
    setOrderBy({
      orderBy: 'code',
      orderByAscending: true,
      pageSize: systemSettings.defaultPageSize,
      generalText1: generalText,
    })

    await fetchData(appContext.api, orderBy);
  }

  function onHeaderClick(header: any) {
    // if (ediRef.current !== -1) {
    //   return;
    // }

    //let newOrderBy = { ...orderBy, orderByAscending: !orderBy.orderByAscending };

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }

      removeData();
      sortingListData(CodeScheduleBListItem, data, setData, orderBy);
    }

    // const sortResult = sortSettingListData(data ?? [], newOrderBy, codesAesScheduleBList.columns);

    // if (sortResult.sorted) {
    //   setData(sortResult.data);
    // }

  }

  // async function requestOperationCancel() {
  //   const doCancel = await showGlobalYesNoDialog(<p>Are you sure you want to cancel Edit operation</p>);
  //   if (doCancel) {
  //     cancelOperation(false)
  //   } else {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80);
  //   }
  // }

  // async function onRowIndexChanged(rowIndex:number) {
  //   if (rowIndex < 0 && ediRef.current >= 0) {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80)
  //     return;
  //   }

  //   if (ediRef.current >= 0 && ediRef.current !== rowIndex) {
  //     await requestOperationCancel();
  //   }
  // }

  // function onRowSelect(rowIndex:number) {
  //   if (rowIndex >= 0 && rowIndex < dataRef.current.length && _.isEmpty(inlineElement) && (listSec?.grantEdit || listSec?.grantDel)) {
  //     setHasChanges(true);
  //     inlineElement = {...dataRef.current[rowIndex], isNew: false};
  //     setEi(rowIndex);
  //   }
  // }

  // function selectForNew() {
  //   inlineElement = {
  //     code: '', sdescription: '', unit1: '', unit2: '', isNew: true,
  //   };
  //   data.unshift(inlineElement);
  //   setData(data);
  //   setEi(0);
  //   setHasChanges(true);
  // }

  // function cancelOperation(leaveNew:boolean=false) {
  //   setHasChanges(false);

  //   //clearTableSelection();
  //   setEi(-1);

  //   if (!leaveNew && inlineElement.isNew) {
  //     dataRef.current.splice(0, 1);
  //     setData(dataRef.current);
  //   }

  //   //inlineElement = {};
  // }

  function deleteEntity(index:number): boolean {
    if(!data){
      return false;
    }

    const element = data[index];
    if(!element.isNew){
      let deleteRow = savedDataRef.current.find(x=>x.code === element.code);
      if(deleteRow){
        deleteRow.isDelete = true;
      }
    }

    data.splice(index, 1);
    setData(data);
    const tempData = data.map((a: CodeScheduleBListItem) => a.code.toLowerCase());
    const newData = allData.splice(0,tempData.length,tempData);
    setAllData(newData);
    return true;   
  }

  function getIndexOfFirstInvalidCell(rowIndex: number):number|undefined {
    if(!data){
      return undefined;
    }
    if(!data[rowIndex].code){
      return 1;
    }
    if (allData) { //기존데이터 목록
      const newData = [...allData];
      if(newData.filter(x => x === data[rowIndex].code.toLowerCase()).length === 0) // 현재 목록에 없음
      {
        newData.splice(rowIndex, 1, data[rowIndex].code.toLowerCase());
        setAllData(newData);
        return undefined;
      }else{
        if(newData[rowIndex] === data[rowIndex].code.toLowerCase()) return undefined;
        else{
          showGlobalOkDialog(<p>'{data[rowIndex].code}' is a duplicate value.</p>);
          return 1;
        }
      }
    } 
    else {
      const newData = [data[rowIndex].code.toLowerCase()];
      setAllData(newData);
    }
    return undefined;
  }

  async function duplicateCell(checkData: any) {
    if (!data) {
      return;
    }

    let duplicateFieldText = '';

    let isDuplicate = false;
    let insList = checkData.filter((x: any) => x.isNew === true);
    let chgList = checkData.filter((x: any) => x.hasBeenChanged === true && !x.isNew);
    let focusRow = -1;

    if (insList.length > 0 && data.length > 0) {
      for (let i = 0; i < insList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (insList[i].code.toUpperCase() === data[j].code.toUpperCase()) {
            if (count === 0) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${insList[i].code}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (chgList.length > 0 && data.length > 0) {
      for (let i = 0; i < chgList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (chgList[i].code.toUpperCase() === data[j].code.toUpperCase()) {
            if (!data[j].isNew && data[j].hasBeenChanged === true && tempRow === -1) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${chgList[i].code}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (!isDuplicate) {
      const apiResult = await appContext.api.checkDuplicatedKeys(JobNames.ScheduleB, listItemType, insList, chgList);
      if (apiResult && apiResult.success && apiResult.message) {
        duplicateFieldText = `${apiResult.message}`;
        isDuplicate = true;
      } else if (!apiResult || !apiResult.success) {
        await showGlobalOkDialog('Could not check duplication.\r\nPlease try later.');
        return true;
      }
    }
    else
      await showGlobalOkDialog(`${duplicateFieldText}Please try after correcting duplication.`);

    return isDuplicate;
  }

  async function save() {
    // if (!inlineElement.isNew && !hasChanges) {
    //   cancelOperation();
    //   return;
    // }

    //<pt220818: portal
    // const apiResult = inlineElement.isNew
    //   ? await appContext.api.createCodesScheduleB(_.omit(inlineElement, ['isNew']))
    //   : await appContext.api.editCodesScheduleB({
    //     oldCode: data[ei].code,
    //     ..._.omit(inlineElement, ['isNew']),
    //   });

    // if (!apiResult || !apiResult.success) {
    //   return;
    // }

    // data[ei] = formatElement(apiResult.data);
    // const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType,
    //   inlineElement.isNew ? SQLType.Insert : SQLType.Update,
    //   _.omit(inlineElement, ['isNew']));
    // if(!apiResult.success) {
    //   await showGlobalOkDialog(<p>{apiResult.message}</p>);
    //   return;
    // }

    //code is pkey
    //data[ei] = formatElement(inlineElement);
    //pt220818>

    //  cancelOperation(true);
    //await showGlobalOkDialog(<p>The data has been saved</p>);
    if (!data) {
      return;
    }

    let validData = data.filter((x:any) => x.code);

    let errMsg = '';
    const dataToSave = validData.filter((x: any) => x.isNew || x.hasBeenChanged === true);
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(orderBy.generalText1);
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult: ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      if (!apiResult || !apiResult.success)
        errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }

    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave);
      if(isDuplicate){
        setLoading(false);
        return;
      }
      const cidData = dataToSave.map((a: CodeScheduleBListItem) =>a.cid?.toLowerCase()) as Array<String>;

      const secondSave = dataToSave.filter((x: CodeScheduleBListItem) => cidData.includes(x.code?.toLowerCase()));
      const firstSave = dataToSave.filter((x: CodeScheduleBListItem) => !secondSave.includes(x));

      if (firstSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, firstSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);

        else {
          firstSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.code === x.code);
            if (index >= 0) {
              data[index].cid = x.code;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          })
        }
      }
      if (secondSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, secondSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);

        else {
          secondSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.code === x.code);
            if (index >= 0) {
              data[index].cid = x.code;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          })
        }
      }
    }

if(errMsg) {
  await showGlobalOkDialog(<p>{errMsg}</p>);
  setLoading(false);
  return;
}    

// setData(data);
// savedDataRef.current = _.cloneDeep(data);
// oriData.current = _.cloneDeep(data);

// setLoading(false);
// setHasChanges(false);
reload(orderBy.generalText1);

await showGlobalOkDialog(<p>The data has been saved</p>);
}

  function applyToLineItem(rowIndex: number, change: Partial<EditableCodeExportInfoListItem>|null) {
    if (!change || !data) {
      return;
    }
    const newData = [...data];
    const checkData = data[rowIndex];
    if (!change.isNew && (change.code !== checkData.code || change.sdescription !== checkData.sdescription ||
      change.unit1 !== checkData.unit1 || change.unit2 !== checkData.unit2)) {
    _.merge(newData[rowIndex], {..._.omit(change, ['isNew']), hasBeenChanged: true});
    setData(newData);
    //setHasChanges(true);
      }
  }
  
  // function addingLineToFirstLine(){
  //   addingToTheFirstLine.current = true;
  //   masterTableRef.current?.add();
  // }

  function addLineItem() {
    const newRow = new EditableCodeExportInfoListItem();
    newRow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newRow
    };
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-aes-scheduleb-list',
    ref: tableRef,
    selectable: true,
    tableName: 'scheduleBList',
    ...codesAesScheduleBList,
    height: `${tableHeight}px`,
    data: (data ?? []).map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem})),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'code',  EditCell: CodeRenderer },
      { accessor: 'sdescription',  EditCell: DescriptionRenderer },
      { accessor: 'unit1',  EditCell: Unit1Renderer},
      { accessor: 'unit2', EditCell: Unit2Renderer },
      //{ accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'code')
        return { type: TableCellTypes.Text, value: data[rowIndex].code };
      else if (accessor === 'sdescription')
       return { type: TableCellTypes.Text, value: data[rowIndex].sdescription };
      else if (accessor === 'unit1')
        return { type: TableCellTypes.Text, value: data[rowIndex].unit1, align: TableCellAligns.Center};
      else if (accessor === 'unit2')
        return { type: TableCellTypes.Text, value: data[rowIndex].unit2, align: TableCellAligns.Center};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },
    
    orderBy: [orderBy],
    onHeaderClick,
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel)
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = listSec?.grantAdd;

  return (
    <div style={{marginTop: '40px'}}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>AES <FontAwesomeIcon icon={faAngleRight} />&nbsp;Schedule B</h1>
        <div style={{width: '320px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})} />
        </div>
      </Portal> */}
      
      {/* <div className="reference-codes-title-row"> */}

          {/* <div style={{marginLeft: '10px', fontSize: '11px', fontWeight: 'bold'}}>
            Double Click Schedule B to Edit
          </div> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element">
            <GreenButton size="regular" disabled={loading} onClick={save}>Save</GreenButton>
          </div>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='list-screen-refresh' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={() => { reload(orderBy.generalText1) }} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>

      <div style={{ display: 'flex', width: '864px' }}>
        <div style={{ width: '320px', fontSize: '11px', fontWeight: 'bold' }}>
          <ClearableSearch
            initialValue={orderBy?.generalText1 || ''}
            onSearch={async generalText1 => {
              await reload(generalText1 === null ? '' : generalText1);
            }}
          />
        </div>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          {//<SecondaryButton name='codes-scheduleb-add-button' size="regular" disabled={!canBeAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} />&nbsp; Add Line</SecondaryButton> &nbsp; 
          }
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(orderBy.generalText1) }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      {/* </div> */}
      <div style={{ width: '864px' }}>
        {/* <SmartTable {...tableOptions} /> */}
        <EditableTable
          initializeFocusedCell={focusFirstCell}
          ref={masterTableRef}
          tableOptions={tableOptions}
          deleteLine={deleteEntity}
          addLine={addLineItem}
          getIndexOfFirstInvalidCell={getIndexOfFirstInvalidCell}
        />
      </div>
    </div>
  );
}

export default Scheduleb;
